export function makeInitials(full_name) {
  return full_name
    .split(/(?:\s+)/g)
    .map((w) => w.charAt(0))
    .join("")
    .toUpperCase();
}
